const STORAGE_KEY = 'terra-proxy-torch-not-supported-toast';

export const TORCH_NOT_SUPPORTED_TOAST_DURATION_MS = 8000;

export const queueTorchNotSupportedToast = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(STORAGE_KEY, '1');
};

export const consumeTorchNotSupportedToast = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const isPending = sessionStorage.getItem(STORAGE_KEY) === '1';

  sessionStorage.removeItem(STORAGE_KEY);

  return isPending;
};

export const clearTorchNotSupportedToast = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(STORAGE_KEY);
};
